function addItemsToCart(cartItems)
{
    // cartItems param needs to be an array of items to add like this like this
    // [ { id: 46126652358945, quantity: 1 }]
    var data = {
        items: cartItems
    };

    // Step 1 Fetch: add items to cart
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            "Accept": "application/javascript"
        },
        body: JSON.stringify(data)
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
    })
    .then(json => {
        return fetch('/?sections=cart-side');
    })
    .then(response => response.json())
    .then(cartSlideOut => {
        var cartSlideOutHTML = cartSlideOut['cart-side'];
        // Convert string to real DOM nodes using DOMParser
        const parser = new DOMParser();
        const doc = parser.parseFromString(cartSlideOutHTML, 'text/html');
        const cartSlideOutHTMLContent = doc.querySelector('.side-panel-content');

        console.log(cartSlideOutHTMLContent);
        // inject html onto slide out - there may be several places
        document.querySelectorAll('#side-cart .side-panel-content').forEach(el => {
            el.innerHTML = cartSlideOutHTMLContent.outerHTML;
        });

        // slide out the cart
        document.querySelector('#quick_cart').click();            
    })
    .catch(err => console.error('Error:', err));
}